import api from './api';

export default {
  login(user, password) {
    return api.post('api/token/access/', {
      'username': user,
      'password': password
    });
  }
};
